import { create } from 'zustand'
import type { AssetAlbum, AssetType } from '../domain/canvas/value-objects/asset'

type AssetPanelState = {
  // UI State
  isOpen: boolean
  selectedAlbum: AssetAlbum | null
  searchText: string
  assetType: AssetType
  hasSeenAssistant: boolean

  // Actions
  openPanel: (type: AssetType) => void
  closePanel: () => void
  selectAlbum: (album: AssetAlbum) => void
  clearAlbum: () => void
  setSearchText: (text: string) => void
  clearSearch: () => void
  dismissAssistant: () => void
}

export const useAssetPanelStore = create<AssetPanelState>((set) => ({
  // Initial state
  isOpen: false,
  selectedAlbum: null,
  searchText: '',
  assetType: 'print',
  hasSeenAssistant: localStorage.getItem('hasSeenAssetAssistant') === 'true',

  // Actions
  openPanel: (type: AssetType) =>
    set(() => ({
      isOpen: true,
      assetType: type,
      selectedAlbum: null,
      searchText: '',
    })),

  closePanel: () =>
    set(() => ({
      isOpen: false,
      selectedAlbum: null,
      searchText: '',
    })),

  selectAlbum: (album: AssetAlbum) =>
    set(() => ({
      selectedAlbum: album,
      searchText: '', // Clear search when selecting album
    })),

  clearAlbum: () =>
    set(() => ({
      selectedAlbum: null,
    })),

  setSearchText: (text: string) =>
    set(() => ({
      searchText: text.trim(),
      selectedAlbum: null, // Clear album when searching
    })),

  clearSearch: () =>
    set(() => ({
      searchText: '',
    })),

  dismissAssistant: () => {
    localStorage.setItem('hasSeenAssetAssistant', 'true')
    set(() => ({
      hasSeenAssistant: true,
    }))
  },
}))
